module.exports = __webpack_public_path__ + "img/ultra_1_banner.f76c3dcc.jpg";